import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-login",
  template: " <p>Login here</p> ",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {}
